// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { DatagramBuf } from '../datagram/datagram-buf.js';
import { FileSha256HashBuf } from '../file/file-sha256-hash-buf.js';
import { TransferIdBuf } from '../status/transfer-id-buf.js';
import { UserIdBuf } from '../user/user-id-buf.js';


export class EditItemWithPathLocalDatagramBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EditItemWithPathLocalDatagramBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEditItemWithPathLocalDatagramBuf(bb:flatbuffers.ByteBuffer, obj?:EditItemWithPathLocalDatagramBuf):EditItemWithPathLocalDatagramBuf {
  return (obj || new EditItemWithPathLocalDatagramBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEditItemWithPathLocalDatagramBuf(bb:flatbuffers.ByteBuffer, obj?:EditItemWithPathLocalDatagramBuf):EditItemWithPathLocalDatagramBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EditItemWithPathLocalDatagramBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

transferId(obj?:TransferIdBuf):TransferIdBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new TransferIdBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

userId(obj?:UserIdBuf):UserIdBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new UserIdBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

path():string|null
path(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
path(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

checksum(obj?:FileSha256HashBuf):FileSha256HashBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? (obj || new FileSha256HashBuf()).__init(this.bb_pos + offset, this.bb!) : null;
}

datagram(obj?:DatagramBuf):DatagramBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? (obj || new DatagramBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startEditItemWithPathLocalDatagramBuf(builder:flatbuffers.Builder) {
  builder.startObject(5);
}

static addTransferId(builder:flatbuffers.Builder, transferIdOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, transferIdOffset, 0);
}

static addUserId(builder:flatbuffers.Builder, userIdOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, userIdOffset, 0);
}

static addPath(builder:flatbuffers.Builder, pathOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, pathOffset, 0);
}

static addChecksum(builder:flatbuffers.Builder, checksumOffset:flatbuffers.Offset) {
  builder.addFieldStruct(3, checksumOffset, 0);
}

static addDatagram(builder:flatbuffers.Builder, datagramOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, datagramOffset, 0);
}

static endEditItemWithPathLocalDatagramBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 4) // transfer_id
  builder.requiredField(offset, 6) // user_id
  builder.requiredField(offset, 8) // path
  builder.requiredField(offset, 10) // checksum
  builder.requiredField(offset, 12) // datagram
  return offset;
}

}
